interface FazendinhaCustomer {
  customer_id: number
  name: string
  email: string
  token: string
  afiliadoId: string
}

export default function parser(user: FazendinhaCustomer): {
  id: string
  name: string
  email: string
  token: string
  afiliadoId: string
} {
  return {
    id: user.customer_id.toString(),
    name: user.name,
    email: user.email,
    token: user.token,
    afiliadoId: user.afiliadoId,
  }
}
